import dayjs from 'dayjs';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';
import { makeZodI18nMap } from 'zod-i18n-map';

import { i18nConfig } from '@/lib/i18n/config';
import { AVAILABLE_LANGUAGES } from '@/lib/i18n/constants';

const updateDocumentProperties = (langKey: string) => {
  const language = AVAILABLE_LANGUAGES.find(({ key }) => key === langKey);
  document.documentElement.lang = langKey;
  document.documentElement.dir = language?.dir ?? 'ltr';
  document.documentElement.style.fontSize = `${(language?.fontScale ?? 1) * 100}%`;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(i18nConfig)
  .then(() => {
    dayjs.locale(i18n.language);
    z.setErrorMap(makeZodI18nMap());
    updateDocumentProperties(i18n.language);
  });

i18n.on('languageChanged', () => {
  window.location.reload();
});

export default i18n;
